import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Plus, FileText, ExternalLink, Code2, Copy } from "lucide-react";
import api from "../../lib/api";
import { PageHeader, Card, Badge, Empty, RedButton, GhostButton } from "../../components/crm/ui";
import FormBuilder from "./FormBuilder";

export default function Forms() {
  const [forms, setForms] = useState([]);
  const [tab, setTab] = useState("all");
  const [building, setBuilding] = useState(false);

  const load = () => api.get("/forms").then(({ data }) => setForms(data.items)).catch(() => {});
  useEffect(() => { load(); }, []);

  const copy = (text, label) => { navigator.clipboard.writeText(text); import("sonner").then(({ toast }) => toast.success(`${label} copied`)); };

  if (building) return <FormBuilder onDone={() => { setBuilding(false); load(); }} onCancel={() => setBuilding(false)} />;

  return (
    <div>
      <PageHeader title="Form Builder" subtitle="Hosted + embeddable forms that create contacts automatically.">
        <RedButton onClick={() => setBuilding(true)} data-testid="forms-create"><Plus size={15} /> Create Form</RedButton>
      </PageHeader>

      {forms.length === 0 ? (
        <Card className="p-6"><Empty icon={FileText} title="No forms yet" hint="Create a hosted form with a QR code and embed code in seconds." action={<RedButton onClick={() => setBuilding(true)}><Plus size={15} /> Create Form</RedButton>} /></Card>
      ) : (
        <div className="grid md:grid-cols-2 gap-4">
          {forms.map((f) => (
            <Card key={f.id} className="p-5" data-testid={`form-card-${f.id}`}>
              <div className="flex items-start justify-between">
                <div>
                  <h3 className="font-display font-bold text-slate-900">{f.name}</h3>
                  <p className="text-xs text-slate-500 mt-1">{f.source} · {f.submission_count || 0} submissions</p>
                </div>
                <Badge tone={f.status === "active" ? "green" : "slate"}>{f.status}</Badge>
              </div>
              <div className="mt-4 space-y-2">
                <div className="flex items-center gap-2">
                  <a href={f.hosted_url} target="_blank" rel="noreferrer" className="flex-1 text-xs text-slate-600 bg-slate-50 rounded-md px-3 py-2 truncate hover:text-alto-red" data-testid={`form-hosted-${f.id}`}>{f.hosted_url}</a>
                  <GhostButton className="!p-2" onClick={() => copy(f.hosted_url, "Hosted URL")}><Copy size={14} /></GhostButton>
                  <a href={f.hosted_url} target="_blank" rel="noreferrer" className="p-2 border border-slate-200 rounded-md hover:bg-slate-50 text-slate-600"><ExternalLink size={14} /></a>
                </div>
                <div className="flex items-center gap-2">
                  <div className="flex-1 text-xs text-slate-500 bg-slate-50 rounded-md px-3 py-2 flex items-center gap-1.5"><Code2 size={13} /> Embed code</div>
                  <GhostButton className="!p-2" onClick={() => copy(f.embed_code, "Embed code")} data-testid={`form-embed-${f.id}`}><Copy size={14} /></GhostButton>
                </div>
              </div>
            </Card>
          ))}
        </div>
      )}
    </div>
  );
}
